import { BrowseByTagsType, ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import {
  QueryParamsUpdates,
  QueryParamsUpdateType,
  UseDishFirstExploreUrl,
} from 'src/pages/consumer/explore/useExploreUrl';
import { useTracker } from 'src/shared/hooks/useTracker';
import { scrollWindowToTop } from 'src/shared/utils/WindowUtils';
import { FilterCard as BaseFilterCard } from '../FilterCard';
import { BrowseByTagsFilterTags } from './types';
import { generateFilters } from './utils';

export type BrowseByTagsFilterButtonProps = {
  tag: BrowseByTagsFilterTags;
  queryParam: QueryParams;
  icon: JSX.Element;
  label: string;
  filters: UseDishFirstExploreUrl;
  position: number;
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
};

/**
 * Functions like the Explore filters
 */
export const FilterCard: React.FC<BrowseByTagsFilterButtonProps> = ({
  tag,
  queryParam,
  icon,
  label,
  filters,
  position,
  updateQueryParams,
}) => {
  const tracker = useTracker();

  const onClick = useCallback(() => {
    const newFilters = generateFilters(filters, queryParam, tag);
    updateQueryParams(newFilters, 'pushIn');
    scrollWindowToTop();
    tracker.track(ClientEvents.BROWSE_BY_TAGS_CLICK, { tag, type: BrowseByTagsType.DIETARY_PREFERENCE, position });
  }, [updateQueryParams, filters, queryParam, tag, position, tracker]);

  return <BaseFilterCard icon={icon} label={label} onClick={onClick} />;
};
